import { FornecedoresEstrutura } from './fornecedores-estrutura';

export class Premissas {
  fantasia: string;
  eUsu: string;
  eHost: string;
  ePorta: string;
  eSenha: string;
  essl: string;
  etls: string;
  assinaturaEmail: string;
  nfeCobranca: boolean;
  fornecedoresEstrutura: string;
  dadosFornecedoresEstrutura: FornecedoresEstrutura;
  prazoExpOrc: number;
  textoKitFechado: string;
  validarKitCustomizado: boolean;
  telhadoCalc: boolean;
  fornEstruturaPadrao?: number;
  cadIntFisico: boolean;
  freteMinimo: number;
  txRural: number;
  usarTbFrete: boolean;
  prazoRetirarReserva: number;
  dadosObgMonitores: boolean;
  verPrecoProdutos: boolean;
  vendedorPadrao?: number;
  mostrarVendaAvulso: boolean;
  descPadrao: boolean;
  freteAut: boolean;
  tipoCalculo: number;
  txVendaDireta: number;
  txVendaDiretaFob: number;

  usarFidelidade: boolean;
  nomeFidelidade: string;
  imagemFidelidade: any;
  imagemFidelidadeBase64: string;
  validadeFidelidade: number;
  regraFidelidade: number;
  desativarPaisagem: boolean;
  qtdKitSug: number;
  mostrarCodErp: boolean;
  obsNoItem: boolean;
  usarPrecoAvulso: boolean;
  compConfObg: boolean;
  novoEndEntrega: boolean;
  integradorAnexar: boolean;
  mostrarVenContato: boolean;
  mostrarDadosFinanceiros: boolean;
  mostrarBifasico: boolean;
  multiFornecedores: boolean;
  limiteRepasse: number;
  usarCombImp: boolean;
  usarTelCeramico: boolean;
  usarTransformador: boolean;
  usarCombInvStrCon: boolean;
  mostrarNumeroSerie: boolean;
  prazoConfirmacao: number;
  alterarValorFinal: boolean;
  cnaes: string;
  mostrarCotDolar: boolean;
  exibirAnexoDistribuidora: boolean;
  kitProntoFrete: boolean;
  kitProntoDesconto: boolean;
  textoFibrometal: string;
  adProdKitPronto: boolean;
  confirmarSemValidar: boolean;
  idModEmailVoucherInt?: number;
  idModEmailVoucherVen?: number;
  ativarVoucher: boolean;
  boletoFotus: boolean;
  bloqClonar: boolean;
  bloqExcluirAnexo: boolean;
  mostrarRecebimentosDashboard: boolean;
  integVerVlServico: boolean;
  centroDeDistribuicao: boolean;
  dispEstoque: boolean;
  vendAlterarFrete: boolean;
  qtdDiasLigacao: number;
  usarEstruturaAutomatica: boolean;
  usarDescarga: boolean;
  usarQuestionarioEntrega: boolean;
  respostasQuestionarioEntregaObg: boolean;
  usarServicoEntrega: boolean;
  usarSeguro: boolean;
  usarValorProjeto: boolean;
  simFin: string;
  freteManualAvulso: boolean;
  freteAdicionarServico: boolean;
  usarEstoqueMinimo: boolean;
  usarMultiFormaPagamento: boolean;
  bloqPedidoSemEstoqueDisp: boolean;
  trocarRazaoPorNomeFantasia: boolean;
  naoRespTimePesqCliente: boolean;
  inscricaoEstadualObg: boolean;
  descInicialKit: string;
  idMarcaKit: number;
  mostrarDescKit: boolean;
  gerarKitMaiusculo: boolean;
  qtdPainelPorFileira: number;
  ajustarValorKitAut: boolean;
  qtdDiasBloqueioAutomatico?: number;
  monConferenciaTecnica: boolean;
  monVerificacao: boolean;
  monAnaliseFinanceira: boolean;
  monFaturamento: boolean;
  usarAcrescimo: boolean;
  ocultarColunaDescricaoFileiras: boolean;
  pedirCodErpIntegracao: boolean;
  informarDadosSeparacao: boolean;
  nomeContratoParceria: string;
  usarDocuSign: boolean;
  marketPlace: boolean;
  mostrarPesquisaGeral: boolean;
  vendaProgramada: boolean;
  freteAdicionarSeguro: boolean;
  venDiNaoAltEndPJ: boolean;
  qtPainelPorFileiraGestaoKit: number;
  intPodeAlterarCD: boolean;
  integracaoSolaryum: boolean;
  mostrarMsgTrocaCD: boolean;
  msgTrocaCD: string;
  estoqueVirtual: boolean;
  usarCalculoMppt: boolean;
  adicionarVariosKitPronto: boolean;
  bloqProdZeradoApi: boolean;
  usarFormulaRepasseCif: boolean;
  descClienteSobreporVendedor: boolean;
  msgEnderecoAdicional: string;
  calcCondPagNoFinal: boolean;
  calcValorFinalSugestao: boolean;
  removerItemSugEdicao: boolean;
  usarReservaManual: boolean;
  dadosSeparacaoObg: boolean;
  visualizacaoKitFechado: number;
  opcaoAssContrato: number;
  cadOrcCRM: number;
  crmVisualizarValor: boolean;
  crmEditarAtividade: boolean;
  confMudEtapaCRM: boolean;
  pergAlterarAtividade: boolean;
  integradorPodeAbrirOcorrencia: boolean;
  codEverest: string;
  regraValidacaoKitPersonalizado: number;
  estoqueUnicoLote: boolean;
  bloquearManutencaoProd: boolean;
  valorArredondamento: number;
  usarCRM: boolean;
  textoMonteSeuKit: string;
  textoAvulso: string;
  textoNovoKitPronto: string;
  textoNovoKitPlus2: string;
}
